import { useEffect, useRef, useState } from "react";

let io;
const listeners = new WeakMap();
const observe = (el, cb) => {
  if (typeof IntersectionObserver === "undefined") { cb(); return () => {}; }
  io = io || new IntersectionObserver((entries) => entries.forEach((e) => {
    if (e.isIntersecting) { listeners.get(e.target)?.(); io.unobserve(e.target); }
  }), { rootMargin: "0px 0px -8% 0px" });
  listeners.set(el, cb);
  io.observe(el);
  return () => io.unobserve(el);
};

/** Aparición suave al entrar en pantalla (CSS + un único IntersectionObserver, sin librerías). */
export const Reveal = ({ delay = 0, className = "", children, ...rest }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => observe(ref.current, () => setInView(true)), []);
  return (
    <div ref={ref} className={`tf-reveal ${inView ? "is-in" : ""} ${className}`} style={{ transitionDelay: `${delay}s` }} {...rest}>
      {children}
    </div>
  );
};
